module.exports = __webpack_public_path__ + "img/E262.fc462302.svg";